import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Header } from "@/components/Header";
import { PlanetCard } from "@/components/PlanetCard";
import { api, errMsg } from "@/lib/api";

export default function Feed() {
  const [planets, setPlanets] = useState([]);
  const [sort, setSort] = useState("notable");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    api.get(`/planets/feed?sort=${sort}`).then((r) => setPlanets(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, [sort]);

  const toggleSave = async (p) => {
    try {
      const { data } = await api.post(`/planets/${p.id}/save`);
      setPlanets((ps) => ps.map((x) => (x.id === p.id ? { ...x, saved: data.saved } : x)));
      toast.success(data.saved ? "Saved to your library" : "Removed from library");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="relative z-10 min-h-screen" data-testid="feed-page">
      <Header />
      <main className="mx-auto max-w-7xl px-4 sm:px-6 py-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
          <div>
            <p className="label-mono mb-3">Public signal feed</p>
            <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-slate-50">Signals</h1>
            <p className="text-sm text-slate-400 mt-3 max-w-lg">Worlds other explorers chose to broadcast. React, log an entry, or save them to your archive.</p>
          </div>
          <div className="flex gap-1 p-1 rounded-full bg-white/5 w-fit">
            {[["notable", "Notable"], ["newest", "Newest"]].map(([k, label]) => (
              <button key={k} onClick={() => setSort(k)} data-testid={`feed-sort-${k}`}
                className={`font-mono text-[0.65rem] uppercase tracking-[0.2em] px-4 py-1.5 rounded-full transition-colors ${sort === k ? "bg-cyan-400 text-[#05070D]" : "text-slate-400 hover:text-slate-100"}`}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {loaded && planets.length === 0 && (
          <div className="glass rounded-xl p-12 text-center" data-testid="feed-empty-state">
            <p className="font-display text-lg uppercase tracking-wide text-slate-200">Silence on all channels</p>
            <p className="text-sm text-slate-400 mt-2">No explorer has broadcast a world yet. Make one of yours public to be the first signal.</p>
          </div>
        )}
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6" data-testid="feed-grid">
          {planets.map((p, i) => <PlanetCard key={p.id} planet={p} index={i} onSave={toggleSave} showOwner />)}
        </div>
      </main>
    </div>
  );
}
